import React from "react"
import ArrowBack from "@mui/icons-material/ArrowBackIos"
import ArrowForward from "@mui/icons-material/ArrowForwardIos"
import { PAGE } from "pages/Plans/Plans"
import { PLANLIST } from "../../Const"
import styles from "./styles.module.scss"

const formatNumber = (num: string | number) => {
  const numString = typeof num === "number" ? num.toString() : num
  return numString.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

interface Props {
  currentPage: number
  plan: string
  pricing: string
  scrollX: (goRIght: boolean) => void
  isAnnual: boolean
}
/**
 * Step4見積結果画面の見積もり金額の追従ヘッダー
 * @param {number} currentPage - 画面で表示しているプラン
 * @param {string} plan - カード上に表示するプラン
 * @param {string} pricing - タイトル
 * @param {(boolean)=> void} scrollX - 左右のスクロール
 * @param {number} isAnnual - 一括払保険料フラグ
 */
const ScaledDownCard = ({ currentPage, plan, pricing, scrollX, isAnnual }: Props) => {
  const getColor = () => {
    let style: any
    if (plan === PLANLIST.LIGHT) {
      style = styles.green
    } else if (plan === PLANLIST.NORMAL) {
      style = styles.blue
    } else {
      style = styles.beige
    }
    return style
  }
  return (
    <div className={styles.root}>
      <div className={styles.root__left} style={{ opacity: currentPage === PAGE.LIGHT ? 0 : 1 }}>
        <ArrowBack
          className={styles.gray}
          onClick={() => {
            scrollX(false)
          }}
        />
      </div>
      <div className={`${styles.root__center} ${getColor()}`}>
        {plan === PLANLIST.LIGHT && (
          <span>
            ライトプラン{" "}
            {isAnnual ? (
              <>
                <span>{formatNumber(pricing)}</span>円（年間）
              </>
            ) : (
              <>
                <span>{formatNumber(pricing)}</span>／月
              </>
            )}
          </span>
        )}
        {plan === PLANLIST.NORMAL && (
          <span>
            スタンダードプラン{" "}
            {isAnnual ? (
              <>
                <span>{formatNumber(pricing)}</span> 円（年間）
              </>
            ) : (
              <>
                <span>{formatNumber(pricing)}</span>／月
              </>
            )}
          </span>
        )}
        {plan === PLANLIST.PREMIUM && (
          <span>
            フルサポートプラン{" "}
            {isAnnual ? (
              <>
                <span>{formatNumber(pricing)}</span>円（年間）
              </>
            ) : (
              <>
                <span>{formatNumber(pricing)}</span>／月
              </>
            )}
          </span>
        )}
      </div>
      <div className={styles.root__right} style={{ opacity: currentPage === PAGE.FULLSUPPORT ? 0 : 1 }}>
        <ArrowForward
          className={styles.gray}
          onClick={() => {
            scrollX(true)
          }}
        />
      </div>
    </div>
  )
}

export default ScaledDownCard
